import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigationTabs } from '../../components/NavigationTabs/NavigationTabs';
import { fetchPurchasedWithoutReviews } from '../../api/productApi';
import { Product } from '../../types/product';
import { LoadingIndicator } from '../../components/LoadingIndicator/LoadingIndicator';
import styles from './MyReviews.module.scss';

export const MyReviews: React.FC = () => {
    const navigate = useNavigate();
    const [purchasedProducts, setPurchasedProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [activeTab, setActiveTab] = useState<'products' | 'favorites' | 'account'>('account');

    useEffect(() => {
        const loadPurchasedProducts = async () => {
            try {
                const products = await fetchPurchasedWithoutReviews();
                setPurchasedProducts(products);
            } catch (err) {
                setError('Не удалось загрузить купленные товары');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        loadPurchasedProducts();
    }, []);

    const handleTabChange = (tab: 'products' | 'favorites' | 'account') => {
        setActiveTab(tab);
        if (tab === 'products') navigate('/');
        else if (tab === 'favorites') navigate('/favorites');
        else if (tab === 'account') navigate('/account');
    };

    const handleBackClick = () => {
        navigate(-1); // Возврат на предыдущую страницу
    };

    if (loading) {
        return <LoadingIndicator message="Загрузка..." />;
    }

    if (error) {
        return (
            <div className={styles.error}>
                <button
                    className={styles.backButton}
                    onClick={handleBackClick}
                    style={{ width: '88px', height: '33px' }}
                >
                    ← Назад
                </button>
                <div>{error}</div>
            </div>
        );
    }

    return (
        <div className={styles['my-purchases']}>
            <button
                className={styles.backButton}
                onClick={handleBackClick}
                style={{ width: '88px', height: '33px' }}
            >
                ← Назад
            </button>

            <header className={styles["purchases-header"]}>
                <h1 className={styles["purchases-title"]}>Мои отзывы</h1>
                <span className={styles["purchases-count"]}>{purchasedProducts.length}</span>
            </header>

            <main className={styles["purchases-content"]}>
                {purchasedProducts.length > 0 ? (
                    <div className={styles["purchases-grid"]}>
                        {purchasedProducts.map(product => (
                            <article
                                key={product.id}
                                className={styles["course-card"]}
                                onClick={() => navigate(`/my-review/${product.id}`)}
                            >
                                <div className={styles["course-card__media"]}>
                                    <img
                                        src={product.image}
                                        alt={product.title}
                                        className={styles["course-card__image"]}
                                        loading="lazy"
                                    />
                                </div>
                                <div className={styles["course-card__content"]}>
                                    <h2 className={styles["course-card__title"]}>{product.title}</h2>
                                    {product.author && (
                                        <div className={styles["course-card__author"]}>
                                            <span className={styles["author-label"]}>автор</span>
                                            <span className={styles["author-name"]}>{product.author}</span>
                                        </div>
                                    )}
                                    <div className={styles["stars-container"]}>
                                        {[...Array(5)].map((_, i) => (
                                            <span key={i} className={styles["star"]}>★</span>
                                        ))}
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                ) : (
                    <div className={styles["empty-state"]}>
                        <p>У вас пока нет покупок на которые вы можете оставить отзыв</p>
                    </div>
                )}
            </main>

            <footer className={styles["purchases-footer"]}>
                <NavigationTabs
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                />
            </footer>
        </div>
    );
};